import s from './Burger.module.scss';
interface Props {
    onClick: () => void;
}
const Burger = ({ onClick }: Props) => {
    return (
        <button className={s.root} onClick={onClick}>
            <svg
                width="25"
                height="21"
                viewBox="0 0 25 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0 0V1.90909H25V0H0ZM0 9.54545V11.4545H25V9.54545H0ZM0 19.0909V21H25V19.0909H0Z"
                    fill="#2D2C50"
                />
            </svg>
        </button>
    );
};
export default Burger;
